import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async get() {
        try{            
            const response = await axios.get(`WorkShifts`,
            {
                headers: {
                    'page_key': pageKeys.workshifts 
                }
            })                                                           
            return response
        }catch (error){
            throw error
        }
    },    
    async getById(workShiftId) {
        try{            
            const response = await axios.get(`WorkShifts/workshift/${workShiftId}`,
            {
                headers: {
                    'page_key': pageKeys.workshifts 
                }
            })            
            return response
        }catch (error){
            throw error
        }
    },
    async addupdate(data) {
        try{            
            const response = await axios.post(`WorkShifts`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.workshifts 
                }
            })            
            return response
        }catch (error){
            throw error
        }
    },
    async delete(data) {
        try{            
            const response = await axios.post(`WorkShifts/delete`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.workshifts 
                }
            })            
            return response
        }catch (error){
            throw error
        }
    }
}